import React from 'react';
import { formatDate, formatCurrency } from '../../../lib/utils';
import { CurrencyTypes } from '../../../lib/systemVariables';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import UpdateApplicationAmtInput from '../../commonComponents/shared/UpdateApplicationAmtInput';
import { ApplicationStatuses } from '../../../lib/systemVariables';
import ApplicationActionsDropdown from '../../commonComponents/shared/ApplicationActionsDropdown';

export default class CampaignListApplicationsTableRow extends NavigationComponent {
    render() {
        const { applicationId, recipientId, firstName, lastName, orgName, creationDate, status, amount, 
                orgEmployment, currency, checkDate,  checkNumber, approverId, inquire, inquireNote, isFirstTime } = this.props.applicationData;
        
        const { userId, admin} = this.props;
        const canApprove = this.props.permissions.approveFull || this.props.permissions.approveLimited;
        const canManage = this.props.permissions.manage;
        const showStatusDropDown = canManage &&
             (((status !== ApplicationStatuses.Review && status !== ApplicationStatuses.New) && (admin || userId === approverId)) ||
             ((status === ApplicationStatuses.Review || status === ApplicationStatuses.New) && canApprove));

        return (
            <HoverTableRow onDoubleClick={this.pushRouteWithProps.bind(this,
                `/recipient-accounts/${recipientId}?applicationId=${applicationId}`, {
                    prevPage: `${this.props.campaignListName} Campaign List Applications`,
                    campaignId: this.props.campaignId,
                    campaignListId: this.props.campaignListId,
                    applicationId
                })}>
                <td data-label="First Name">
                    <p>{firstName}</p>
                </td>
                <td data-label="Last Name" className="application-name">
                    <p className="bold-text">
                    {!lastName && orgName ? orgName : lastName}
                        {isFirstTime && status === ApplicationStatuses.New &&
                            <span className="tag first-time">First Time</span>}
                    </p>
                </td>
                <td data-label="Creation Date">
                    <p>{formatDate(creationDate)}</p>
                </td>
                <td data-label="Status">
                    {showStatusDropDown 
                        ? <ApplicationActionsDropdown status={status}
                            locked={this.props.updating}
                            applicationId={applicationId}
                            userId={userId}
                            approverId={approverId}
                            admin={admin}
                            amount={amount}
                            currency={currency}
                            inquire={inquire}
                            inquireNote={inquireNote}
                            update={{ ...this.props.update, loading: this.props.updating }}
                            updateApplicationStatus={async (action, app) => {
                                this.props.updateApplicationStatus(action, app);
                            }}
                            maxAmount={this.props.maxAmount}/> 
                        : <p>{status}</p>}
                </td>
                <td data-label="Amount">
                    {(this.props.tableStatus === ApplicationStatuses.New && canApprove && canManage) 
                        ? <UpdateApplicationAmtInput 
                            application={this.props.applicationData}
                            updating={this.props.updating}
                            updateError={this.props.updateError}
                            update={this.props.updateApplication}
                            maxAmount={this.props.maxAmount}/> 
                        : <p>{formatCurrency(amount, currency === CurrencyTypes.Shekel)}</p>}
                </td>
                <td data-label="Position">
                    <p>{orgEmployment}</p>
                </td>
                <td data-label="Check Date">
                    <p>{formatDate(checkDate)}</p>
                </td>
                <td data-label="Check Number">
                    <p>{checkNumber}</p>
                </td>
            </HoverTableRow>
            
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignListDetails/CampaignListApplicationsTableRow.jsx